<template>
    <v-menu
        open-on-hover
        location="top"
        offset="50"
        close-delay="200"
        transition="slide-y-transition"
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ props }">
            <v-avatar v-if="email" v-bind="props" size="35">
                <img v-if="photo" :src="photo" />
                <v-icon v-else>mdi-account-circle</v-icon>
            </v-avatar>
            <span v-if="!onlyPhoto" class="ml-2">
                <span v-if="user && user.displayName">{{
                    user.displayName
                }}</span>
                <span v-else>{{ email }}</span>
            </span>
        </template>

        <v-card class="userlist">
            <v-list class="transparent">
                <v-list-item>
                    <template v-slot:prepend>
                        <v-avatar>
                            <img v-if="photo" :src="photo" />
                            <v-icon v-else size="large"
                                >mdi-account-circle</v-icon
                            >
                        </v-avatar>
                    </template>
                    <v-list-item-title>
                        <span v-if="user && user.displayName">{{
                            user.displayName
                        }}</span>
                        <span v-else>{{ email }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="user && user.jobTitle">
                        {{ user.jobTitle }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="user && user.officeLocation">
                        {{ user.officeLocation }}
                    </v-list-item-subtitle>
                    <template v-slot:append>
                        <v-btn
                            color="white"
                            icon
                            variant="text"
                            :href="'mailto:' + email"
                            target="_blank"
                        >
                            <v-icon>mdi-email</v-icon>
                        </v-btn>
                    </template>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>
<script setup>
defineProps({
    email: { type: String },
    onlyPhoto: { type: Boolean, default: false },
    user: { type: Object },
    photo: { type: String },
})
</script>
<style scoped>
.userlist {
    background-color: rgba(97, 97, 97, 0.9) !important;
}
.transparent {
    background-color: transparent !important;
}
.tooltip-transp {
    background: none;
    padding: 0;
}
</style>
